module.exports = __webpack_public_path__ + "img/document-text.f89ffb87.svg";